<template>
  <div id="checkout">
    <div class="container">
      <div class="row mt-5">
        <div class="col-md-8 col-md-offset-2 text-center">
          <div v-if="order && order.status === 'Accepted'">
            <h2 class="section-title">Order went through successfully!</h2>
            <br>
            <p>
              You should receive a confirmation email very shortly<template v-if="user && user.email"> on <strong>{{ user.email }}</strong></template>.
              Enjoy your food and do not forget to come back to let us know how it was!
            </p>
            <br>
            <p><strong>Order Number:</strong> #{{ order.order_number }}</p>
            <p v-if="order.type === 'delivery' && order.delivery_address">
              <strong>Delivering to:</strong> {{ order.delivery_address }}<template v-if="order.delivery_postcode">, {{ order.delivery_postcode }}</template>
            </p>
            <br>
            <router-link to="/" tag="button" class="btn btn-danger btn-fill">
              Check more products
            </router-link>
          </div>
          <div v-else-if="order">
            <h2 class="section-title text-red">Order was not successful!</h2>
            <br>
            <p>
              Unfortunately there has been an error while trying to process your payment.<br>
              <strong><u>Error message:</u></strong> <span class="text-red">{{ order.status_message }}</span>
            </p>
            <p>We advise you to go back to checkout and try again.</p>
            <br>
            <br>
            <router-link to="/checkout" tag="button" class="btn btn-danger btn-fill">
              Go back to checkout
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  let kf

  export default {
    name: 'checkout-response',
    data () {
      return {
        paymentIntentId: null,
        orderNumber: null,
        order: null
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    created () {
      kf = this
      this.$store.dispatch('LoadingOn')
    },
    beforeMount () {
      kf.paymentIntentId = kf.$route.query.payment_intent
      kf.orderNumber = kf.$route.query.order_number

      if (!kf.paymentIntentId && !kf.orderNumber) {
        this.$router.push({ name: 'homepage' })
      }

      kf.$store.dispatch('GetOrder', {
        payment_intent: kf.paymentIntentId,
        order_number: kf.orderNumber
      })
        .then(response => {
          kf.order = response.order
          kf.$store.dispatch('LoadingOff')

          if (response.order.status === 'Accepted') {
            kf.notifyVue('success', 'The payment successfully went through.')
            kf.$store.dispatch('UpdateCart', [])
            kf.$store.dispatch('UpdateDiscount', null)
          }
        })
        .catch(error => {
          kf.notifyVue('danger', error.message)
          kf.$store.dispatch('LoadingOff')
        })
    },
    methods: {
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// response.vue?ac5a7a52